import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isMobile } from '../../../screenUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest } from '../../../requestUtils';
import LazyFinish from './LazyFinish';
import './Finish.scss';
import { processedProfileSuggestions } from '../onboardingUtils';
var resourceString = function resourceString(resourceLink) {
  if (resourceLink.includes('project') || resourceLink.includes('proposal')) {
    return 'view my opportunity';
  }
  return 'view open opportunities';
};
var bodyString = function bodyString(isFinished) {
  if (isFinished) {
    return /*#__PURE__*/React.createElement("p", {
      className: "body-text-1"
    }, "Do not forget to", ' ', /*#__PURE__*/React.createElement("b", null, "complete 100%"), ' ', "of your profile to receive better project recommendations and rank higher when searching for candidates.");
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "body-text-1"
  }, "Adding to your profile will ensure that Clora understands your preferences and experience, offering you better suggestions and results..");
};
function Finish(_ref) {
  var userId = _ref.userId,
    resourceLink = _ref.resourceLink,
    csrfToken = _ref.csrfToken,
    name = _ref.name,
    finish = _ref.finish,
    step = _ref.step,
    onboardType = _ref.onboardType,
    percentage = _ref.percentage,
    claimInfoUrl = _ref.claimInfoUrl,
    closeModal = _ref.closeModal;
  var _useSelector = useSelector(function (state) {
      return state.profileSuggestions;
    }),
    profileSuggestions = _useSelector.profileSuggestions,
    errorsProfileSuggestions = _useSelector.errors;
  var onSaveAndExit = function onSaveAndExit() {
    var data;
    analyticsTrack('Exiting from Finish Later', {
      location: 'Onboarding Flow',
      step: step,
      userId: userId
    });
    if (step === 'Start Here') {
      if (errorsProfileSuggestions.is) {
        return;
      }
      data = processedProfileSuggestions(profileSuggestions.merged);
    }
    putRequest(claimInfoUrl, {
      claim_info: data
    }, csrfToken).then(function () {
      window.history.pushState({}, '', resourceLink);
      window.location.reload();
    });
  };
  var onProfileUrl = function onProfileUrl() {
    analyticsTrack('Clicking View my clora profile', {
      location: 'Onboarding Flow',
      step: step,
      userId: userId
    });
  };

  // acts as a stand-in for full onboarding, sort of
  if (name) {
    return /*#__PURE__*/React.createElement("div", {
      className: "style-guide finish-container onboarding-finish-modal"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "welcome-greeting mb-3"
    }, finish ? 'It is time to explore opportunities!' : 'Are you sure you want to exit now?'), bodyString(finish, percentage), /*#__PURE__*/React.createElement("div", {
      className: "d-flex ".concat(finish ? 'g-row--between' : ' finish-later flex-column flex-md-row justify-content-center gap-2')
    }, !finish && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
      tabIndex: 0,
      role: "button",
      className: "btn btn-primary onboard-save-and-exit-btn ".concat(isMobile() ? 'mb-3' : ''),
      id: "onboard-save-and-exit",
      onClick: function onClick() {
        return onSaveAndExit();
      }
    }, "Save and Exit"), /*#__PURE__*/React.createElement("a", {
      tabIndex: 0,
      role: "button",
      className: "btn btn-primary onboard-add-to-profile-btn",
      id: "onboard-view-my-profile",
      onClick: function onClick() {
        return closeModal();
      }
    }, "Cancel")), finish && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
      className: "btn btn-secondary text-capitalize finish-resource-btn",
      id: "onboard-view-my-profile",
      onClick: function onClick() {
        return onProfileUrl();
      },
      href: "/users/".concat(userId, "/onboard")
    }, "view my clora profile"), /*#__PURE__*/React.createElement("a", {
      className: 'btn btn-primary text-capitalize ' + 'onboard-resource-link finish-resource-btn',
      id: "onboard-resource-link",
      href: resourceLink
    }, resourceString(resourceLink)))));
  }
  return /*#__PURE__*/React.createElement(LazyFinish, {
    csrfToken: csrfToken,
    onboardType: onboardType
  });
}
Finish.propTypes = {
  resourceLink: PropTypes.string.isRequired,
  name: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  finish: PropTypes.bool.isRequired,
  onboardType: PropTypes.string.isRequired,
  percentage: PropTypes.number,
  step: PropTypes.string.isRequired,
  userId: PropTypes.string,
  claimInfoUrl: PropTypes.string,
  closeModal: PropTypes.func
};
Finish.defaultProps = {
  claimInfoUrl: null,
  name: null,
  percentage: null,
  userId: null
};
export default Finish;